import { FiSettings } from 'react-icons/fi'

import { t } from 'i18next'

import { Button } from '~/components/Buttons'

const ToggleButton = ({
  onClick,
  disabled = false,
  className
}: CardSelectorToggleButtonProps) => (
  <Button
    className={className}
    disabled={disabled}
    iconLeft={<FiSettings />}
    onClick={onClick}
    size="small"
    template="tertiary"
    text={t('rm:metrics.cards.customize.button')}
    type="button"
  />
)

export default ToggleButton
